<div class="chipChoiceDs chipChoiceDs--{{style}} chipChoiceDs--{{state}} chipChoiceDs--{{style}}--{{size}}" (click)="clickTrigger()">
  <div *ngIf="icon" class="chipChoiceDs__icon chipChoiceDs__icon--{{style}}">
    <app-ds-icon
      [icon]="icon"
      [color]="iconColor"
      [size]="iconSize">
    </app-ds-icon>
  </div>

  <div class="chipChoiceDs__text chipChoiceDs__text--{{size}}" [class.with-icon]="icon">
    <app-ds-typography
      [fontFamily]="fontFamily.SemiBold"
      [size]="fontSize.XXS"
      [text]="mainText">
    </app-ds-typography>
    <ng-container *ngIf="showSecondaryText">
      <app-ds-typography
        [fontFamily]="fontFamily.Regular"
        [size]="fontSize.XXXS"
        [text]="secondaryText">
      </app-ds-typography>
    </ng-container>
  </div>
</div>